import { LoadingSpinner } from '@components/Generic'
import { observer } from 'mobx-react'
import { useContext, useEffect } from 'react'
import { StoreContext } from '@store/Root.store'
import { axiosInstance } from '@/methods/axiosConfig'
import { forceRedirect } from '@/methods/forceRedirect'
import { API_URL } from '@/constants/apiUrl'

export const OpenbankingMastercardPage = observer(() => {
  const store = useContext(StoreContext)

  const initRedirect = async () => {
    const { data } = await axiosInstance.post<{
      redirectUrl: string
    }>(
      `${API_URL}/mastercard-openbanking/start-session`,
      {},
      {
        withCredentials: true,
      }
    )

    if (data?.redirectUrl) {
      forceRedirect(data.redirectUrl)
    }
  }

  useEffect(() => {
    void initRedirect()
  }, [])

  return (
    <div className="page-container mobile-m-10">
      <LoadingSpinner />
    </div>
  )
})
